export enum WellKnownRateStrategy {
  CARRIER_DIRECT = 'CARRIER_DIRECT',
  CARRIER_DIRECT_VOLUME = 'CARRIER_DIRECT_VOLUME',
  EXCLUDED = 'EXCLUDED',
  P44 = 'PROJECT44',
  P44_VOLUME = 'PROJECT44_VOLUME_LTL',
  PRIORITY1 = 'PRIORITY1',
  RATE_ERROR = 'RATE_ERROR',
}

export const P44_RATE_STRATEGIES = [
  WellKnownRateStrategy.P44,
  WellKnownRateStrategy.P44_VOLUME,
];

export const CARRIER_DIRECT_RATE_STRATEGIES = [
  WellKnownRateStrategy.CARRIER_DIRECT,
  WellKnownRateStrategy.CARRIER_DIRECT_VOLUME,
];
